/* ==========================================================================
   PETLY — interacciones propias. Vanilla, sin librerías.
   Cada init comprueba si su elemento existe, así el archivo sirve en todas
   las páginas. Todo respeta prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var menosMovimiento =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- reveals */
  function initReveals() {
    var elementos = document.querySelectorAll('.mt-reveal, .mt-linea-wrap, .mt-hero');
    if (!elementos.length) return;

    if (menosMovimiento || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('mt-visible');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    elementos.forEach(function (el) { obs.observe(el); });

    /* Red de seguridad: si por lo que sea el observador no dispara (pestaña en
       segundo plano al cargar, navegador raro), nada debe quedarse invisible. */
    setTimeout(function () {
      document.querySelectorAll('.mt-reveal:not(.mt-visible), .mt-linea-wrap:not(.mt-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.2) el.classList.add('mt-visible');
      });
    }, 2200);
  }

  /* ------------------------------------------------------- stagger por grupo */
  function initStagger() {
    document.querySelectorAll('[data-mt-stagger]').forEach(function (grupo) {
      var paso = parseInt(grupo.getAttribute('data-mt-stagger'), 10) || 90;
      var hijos = grupo.querySelectorAll('.mt-reveal');
      hijos.forEach(function (h, i) {
        if (!h.style.getPropertyValue('--mt-delay')) {
          h.style.setProperty('--mt-delay', i * paso + 'ms');
        }
      });
    });
  }

  /* -------------------------------------------------------------- carruseles */
  function initCarruseles() {
    document.querySelectorAll('[data-mt-carrusel]').forEach(function (raiz) {
      var pista = raiz.querySelector('.mt-carrusel__pista');
      if (!pista) return;
      var prev = raiz.querySelector('[data-mt-prev]');
      var next = raiz.querySelector('[data-mt-next]');

      function paso() {
        var slide = pista.querySelector('.mt-carrusel__slide');
        if (!slide) return pista.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(pista).columnGap || '24') || 24;
        return slide.getBoundingClientRect().width + gap;
      }

      function refrescar() {
        if (!prev || !next) return;
        var max = pista.scrollWidth - pista.clientWidth - 2;
        prev.disabled = pista.scrollLeft <= 2;
        next.disabled = pista.scrollLeft >= max;
      }

      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });

      pista.addEventListener('scroll', refrescar, { passive: true });
      window.addEventListener('resize', refrescar);
      refrescar();

      /* arrastre con ratón en escritorio */
      var abajo = false, inicioX = 0, inicioScroll = 0, movido = false;
      pista.addEventListener('mousedown', function (e) {
        abajo = true; movido = false;
        inicioX = e.pageX; inicioScroll = pista.scrollLeft;
        pista.style.cursor = 'grabbing';
        pista.style.scrollBehavior = 'auto';
      });
      window.addEventListener('mouseup', function () {
        abajo = false;
        pista.style.cursor = '';
        pista.style.scrollBehavior = '';
      });
      pista.addEventListener('mousemove', function (e) {
        if (!abajo) return;
        var d = e.pageX - inicioX;
        if (Math.abs(d) > 4) movido = true;
        pista.scrollLeft = inicioScroll - d;
      });
      pista.addEventListener('click', function (e) {
        if (movido) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }

  /* ------------------------------------------------------- escena sticky */
  function initEscenas() {
    document.querySelectorAll('[data-mt-escena]').forEach(function (raiz) {
      var pasos = raiz.querySelectorAll('.mt-escena__paso');
      var capas = raiz.querySelectorAll('.mt-escena__capa');
      if (!pasos.length || !capas.length) return;

      function activar(i) {
        pasos.forEach(function (p, n) { p.classList.toggle('mt-activa', n === i); });
        capas.forEach(function (c, n) { c.classList.toggle('mt-activa', n === i); });
      }
      activar(0);

      if (!('IntersectionObserver' in window)) return;

      var obs = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (e) {
            if (e.isIntersecting) {
              var i = Array.prototype.indexOf.call(pasos, e.target);
              if (i > -1) activar(i);
            }
          });
        },
        { threshold: 0.55, rootMargin: '-20% 0px -20% 0px' }
      );
      pasos.forEach(function (p) { obs.observe(p); });
    });
  }

  /* ------------------------------------------------------------- contadores */
  function initContadores() {
    var nums = document.querySelectorAll('[data-mt-contador]');
    if (!nums.length) return;

    function animar(el) {
      var destino = parseFloat(el.getAttribute('data-mt-contador'));
      if (isNaN(destino)) return;
      var pre = el.getAttribute('data-mt-pre') || '';
      var post = el.getAttribute('data-mt-post') || '';
      var decimales = (String(destino).split('.')[1] || '').length;

      if (menosMovimiento) {
        el.textContent = pre + destino.toFixed(decimales) + post;
        return;
      }
      var dur = 1700, t0 = null;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 4);
        var v = destino * e;
        el.textContent =
          pre + (decimales ? v.toFixed(decimales) : Math.round(v).toLocaleString('es-CO')) + post;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      nums.forEach(animar);
      return;
    }
    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { animar(e.target); obs.unobserve(e.target); }
        });
      },
      { threshold: 0.5 }
    );
    nums.forEach(function (n) { obs.observe(n); });
  }

  /* ---------------------------------------------------------- parallax hero */
  function initParallax() {
    if (menosMovimiento) return;
    var capas = document.querySelectorAll('[data-mt-parallax]');
    if (!capas.length) return;

    var tick = false;
    function pintar() {
      capas.forEach(function (c) {
        var f = parseFloat(c.getAttribute('data-mt-parallax')) || 0.12;
        var r = c.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        var y = (window.innerHeight / 2 - (r.top + r.height / 2)) * f;
        c.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0) scale(1.1)';
      });
      tick = false;
    }
    window.addEventListener(
      'scroll',
      function () { if (!tick) { tick = true; requestAnimationFrame(pintar); } },
      { passive: true }
    );
    pintar();
  }

  /* -------------------------------------------------- galería de producto */
  function initGaleria() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (raiz) {
      var minis = raiz.querySelectorAll('.mt-prod__mini');
      var grandes = raiz.querySelectorAll('.mt-prod__principal img');
      if (!minis.length || !grandes.length) return;

      function mostrar(i) {
        minis.forEach(function (m, n) {
          m.classList.toggle('mt-activa', n === i);
          m.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
        grandes.forEach(function (g, n) { g.classList.toggle('mt-activa', n === i); });
      }
      minis.forEach(function (m, i) {
        m.addEventListener('click', function () { mostrar(i); });
        m.addEventListener('mouseenter', function () { mostrar(i); });
      });
      mostrar(0);
    });
  }

  /* ------------------------------------------------ variantes de producto */
  function initVariantes() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (raiz) {
      var datos = raiz.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      if (!variantes || !variantes.length) return;

      var idInput = raiz.querySelector('[data-mt-id-variante]');
      var precioEl = raiz.querySelector('[data-mt-precio]');
      var antesEl = raiz.querySelector('[data-mt-precio-antes]');
      var ahorroEl = raiz.querySelector('[data-mt-ahorro]');
      var btn = raiz.querySelector('[data-mt-anadir]');
      var grupos = raiz.querySelectorAll('[data-mt-opcion]');

      function dinero(c) {
        var v = (c / 100).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
        return '$' + v;
      }

      function seleccion() {
        var out = [];
        grupos.forEach(function (g) {
          var a = g.querySelector('.mt-prod__valor.mt-activa');
          out.push(a ? a.getAttribute('data-mt-valor') : null);
        });
        return out;
      }

      function actualizar() {
        var sel = seleccion();
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        });

        grupos.forEach(function (g, gi) {
          g.querySelectorAll('.mt-prod__valor').forEach(function (b) {
            var prueba = sel.slice();
            prueba[gi] = b.getAttribute('data-mt-valor');
            var existe = variantes.some(function (x) {
              return x.options.every(function (o, i) { return o === prueba[i]; }) && x.available;
            });
            b.classList.toggle('mt-agotada', !existe);
          });
        });

        if (!v) {
          if (btn) { btn.disabled = true; btn.textContent = 'No disponible'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (precioEl) precioEl.textContent = dinero(v.price);
        if (antesEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            antesEl.textContent = dinero(v.compare_at_price);
            antesEl.hidden = false;
            if (ahorroEl) {
              var pc = Math.round((1 - v.price / v.compare_at_price) * 100);
              ahorroEl.textContent = '-' + pc + '%';
              ahorroEl.hidden = false;
            }
          } else {
            antesEl.hidden = true;
            if (ahorroEl) ahorroEl.hidden = true;
          }
        }
        if (btn) {
          btn.disabled = !v.available;
          btn.textContent = v.available
            ? btn.getAttribute('data-mt-texto') || 'Añadir al carrito'
            : 'Agotado';
        }

        if (v.featured_index != null) {
          var mini = raiz.querySelectorAll('.mt-prod__mini')[v.featured_index];
          if (mini) mini.click();
        }

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* sin drama */ }
      }

      grupos.forEach(function (g) {
        g.querySelectorAll('.mt-prod__valor').forEach(function (b) {
          b.addEventListener('click', function () {
            g.querySelectorAll('.mt-prod__valor').forEach(function (o) { o.classList.remove('mt-activa'); });
            b.classList.add('mt-activa');
            actualizar();
          });
        });
      });

      var menos = raiz.querySelector('[data-mt-menos]');
      var mas = raiz.querySelector('[data-mt-mas]');
      var cant = raiz.querySelector('[data-mt-cantidad]');
      if (menos && mas && cant) {
        menos.addEventListener('click', function () {
          cant.value = Math.max(1, (parseInt(cant.value, 10) || 1) - 1);
        });
        mas.addEventListener('click', function () {
          cant.value = Math.min(99, (parseInt(cant.value, 10) || 1) + 1);
        });
      }

      actualizar();
    });
  }

  /* ------------------------------------------------------ header al hacer scroll */
  function initHeader() {
    var h = document.querySelector('.section-header');
    if (!h) return;
    var ultimo = 0;
    window.addEventListener(
      'scroll',
      function () {
        var y = window.scrollY || 0;
        h.classList.toggle('mt-header-scroll', y > 40);
        ultimo = y;
      },
      { passive: true }
    );
  }


  /* ------------------------------------------------------- menu movil */
  function initMenuMovil() {
    var panel = document.querySelector('[data-mt-menu-movil]');
    var abrir = document.querySelector('[data-mt-menu-abrir]');
    if (!panel || !abrir || abrir.dataset.mtListo === '1') return;
    abrir.dataset.mtListo = '1';

    function abre() {
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('mt-abierto'); });
      document.body.classList.add('mt-sin-scroll');
      abrir.setAttribute('aria-expanded', 'true');
    }
    function cierra() {
      panel.classList.remove('mt-abierto');
      document.body.classList.remove('mt-sin-scroll');
      abrir.setAttribute('aria-expanded', 'false');
      setTimeout(function () { panel.hidden = true; }, 480);
    }

    abrir.addEventListener('click', abre);
    panel.querySelectorAll('[data-mt-menu-cerrar]').forEach(function (b) {
      b.addEventListener('click', cierra);
    });
    panel.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', cierra); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) cierra();
    });
  }

  /* --------------------------------------------------------- selector idioma */
  function initIdioma() {
    document.querySelectorAll('.mt-idioma').forEach(function (raiz) {
      var boton = raiz.querySelector('.mt-idioma__boton');
      if (!boton || boton.dataset.mtListo === '1') return;
      boton.dataset.mtListo = '1';

      function cerrar() {
        raiz.classList.remove('mt-abierto');
        boton.setAttribute('aria-expanded', 'false');
      }
      boton.addEventListener('click', function (e) {
        e.stopPropagation();
        var abierto = raiz.classList.toggle('mt-abierto');
        boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!raiz.contains(e.target)) cerrar();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') cerrar();
      });
    });
  }

  function arrancar() {
    initStagger();
    initReveals();
    initCarruseles();
    initEscenas();
    initContadores();
    initParallax();
    initGaleria();
    initVariantes();
    initHeader();
    initMenuMovil();
    initIdioma();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  /* El editor de Shopify recarga secciones sueltas: reengancha todo */
  document.addEventListener('shopify:section:load', arrancar);
  document.addEventListener('shopify:section:select', arrancar);
})();
